export const ORDER_ARRIVAL_STATUS_ENUM = {
  ORDER_PLACED: 'OrderPlaced',
  ARRIVED: 'Arrived',
  PICKED_UP: 'PickedUp',
};
